/**
 * search_helpers.js — Shared UI helpers for search pages.
 *
 * Consolidates duplicated Foundation-reveal modal logic and saved-search
 * event binding that was previously copy-pasted across 5 modules.
 */
import $ from 'jquery';
import URI from 'urijs';

/**
 * Open a Foundation reveal modal with content fetched from `url`.
 *
 * @param {string} url - AJAX endpoint that returns modal HTML.
 * @param {string} [modalId='#filterModal'] - Selector for the modal container.
 */
export function showModalFromUrl(url, modalId) {
    modalId = modalId || '#filterModal';
    return $.get(url).done(function (response) {
        $(modalId).html(response);
        $(modalId).foundation('reveal', 'open');
        $(modalId).foundation('abide', 'reflow');
    });
}

/**
 * Bind saved-search UI events (dropdown navigation, edit links, save button).
 *
 * @param {Object} opts
 * @param {string} opts.type - Saved-search type sent to the server
 *   ('public_companies', 'public_projects', 'tenders', 'projects').
 * @param {string} [opts.editSelector='#quick-lists a.edit'] - Selector for
 *   the edit link that opens the modal. Workplace pages use '#add-drop a.edit'.
 * @param {boolean} [opts.showSignInModal=false] - If true, check for
 *   '#signin-modal' and open it instead of the save-search form when the
 *   user is not authenticated.
 */
export function initializeSaveSearch(opts) {
    var type = opts.type;
    var editSelector = opts.editSelector || '#quick-lists a.edit';
    var showSignInModal = opts.showSignInModal !== false;

    // Dropdown — navigate to saved search on click
    $('body').on('click', '.flexible-rolldown ul.f-dropdown li', function (e) {
        var $link = $(e.currentTarget).find('a').first();
        if ($link.length && $link.attr('href')) {
            window.location = $link.attr('href');
        }
    });

    // Dropdown — re-bind on toggle (ensures correct handler after DOM updates)
    $('body').on('click', '.flexible-rolldown > a', function () {
        $('body').off('click', '.flexible-rolldown ul.f-dropdown li.saved_search');
        $('body').on('click', '.flexible-rolldown ul.f-dropdown li.saved_search', function (e) {
            window.location = $(e.currentTarget).find('a').first().attr('href');
        });
    });

    // Edit link — open the edit modal
    $(editSelector).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showModalFromUrl($(e.currentTarget).attr('href'));
    });

    // Visibility toggle (inside modal dropdown)
    $(document).on('click', '.f-dropdown a.private-choice', function (e) {
        var $target = $(e.currentTarget);
        $('#visibility-content').html($target.html());
        $('#saved_search_visibility').val($target.data().value);
    });

    // Save button — open sign-in modal or save-search form
    $('#save-search').on('click', 'button', function (e) {
        e.preventDefault();
        if (showSignInModal && $('#signin-modal').length) {
            return $('#signin-modal').foundation('reveal', 'open');
        }
        var uri = new URI(window.location);
        var params = { query_params: JSON.stringify(uri.search(true)), type: type };
        showModalFromUrl('/workplace/saved_searches/new?' + $.param(params));
    });
}
